export default __webpack_public_path__ + "static/media/ProductsList_PC_img2_Hk.7c824b20.webp";